<template>
  <div class="py-3 min-w-0 w-full">
    <div class="display-1 d-flex">
      <span>Muokkaa hyvityslaskua</span>
      <v-spacer></v-spacer>
      <v-btn color="info" @click="goBack()"> Takaisin </v-btn>
    </div>

    <invoice-form
      :inv="invoice"
      save-btn-text="Tallenna luonnos"
      :edit="true"
      @sendrefundinvoice="submit($event)"
    ></invoice-form>
  </div>
</template>

<script>
import mixins from "../../mixins/mixins";
import axiosMethods from "../../mixins/axios";
import InvoiceForm from "../../components/Invoice/InvoiceForm";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  title: "Muokkaa hyvityslaskua",

  components: {
    InvoiceForm,
  },

  mixins: [mixins],

  data() {
    return {
      invoice: {},
      refundedInv: {},
    };
  },

  computed: {
    ...mapState("invoice", ["currentInvoice"]),
  },

  async created() {
    try {
      this.setLoading(true);

      await this.getOneInvoice({ id: this.$route.params.id });
      // Set refund Invoice and current invoice
      const invoice = this.currentInvoice;

      // Set invoice
      this.invoice = {
        ...invoice,
        billDate: new Date(invoice.billDate).toISOString().substring(0, 10),
        accountDate: new Date(invoice.accountDate).toISOString().substring(0, 10),
        dueDate: new Date(invoice.dueDate).toISOString().substring(0, 10),
      };
    } catch (err) {
      this.showPopup(err, "error");
    }
  },

  methods: {
    ...mapMutations("invoice", ["setLoading", "setSaving"]),
    ...mapActions("invoice", ["getOneInvoice"]),

    async submit(data) {
      try {
        await axiosMethods.update(
          `/api/v1/invoices/refund-related/edit/${this.$route.params.id}`,
          data
        );
        this.setSaving(false);

        this.$router.push("/refund-invoices");
        this.showPopup("Hyvityslaskua muokattu", "success");
      } catch (err) {
        this.setSaving(false);
        this.showPopup(err, "error");
      }
    },
  },
};
</script>

<style scoped></style>
